var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 100,
    viewBox: "0 0 70 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3753 100C26.9632 100 34.7447 92.5335 34.7447 83.3335V66.6668H17.3753C7.78742 66.6668 0.00592041 74.1335 0.00592041 83.3335C0.00592041 92.5335 7.78742 100 17.3753 100Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00592041 49.9999C0.00592041 40.7999 7.78742 33.3332 17.3753 33.3332H34.7447V66.6665H17.3753C7.78742 66.6665 0.00592041 59.1999 0.00592041 49.9999Z",
    fill: "#A259FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00390625 16.6667C0.00390625 7.46667 7.7854 7.62939e-06 17.3733 7.62939e-06H34.7427V33.3333H17.3733C7.7854 33.3333 0.00390625 25.8667 0.00390625 16.6667Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7458 7.62939e-06H52.1152C61.7031 7.62939e-06 69.4846 7.46667 69.4846 16.6667C69.4846 25.8667 61.7031 33.3333 52.1152 33.3333H34.7458V7.62939e-06Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4846 49.9999C69.4846 59.1999 61.7031 66.6665 52.1152 66.6665C42.5273 66.6665 34.7458 59.1999 34.7458 49.9999C34.7458 40.7999 42.5273 33.3332 52.1152 33.3332C61.7031 33.3332 69.4846 40.7999 69.4846 49.9999Z",
    fill: "#1ABCFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_767"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69.4915,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.f720b89b9922a523e47d9e45b035335b.svg";
export { ForwardRef as ReactComponent };